export const PROPOSALS_TO_SHOW = 10
export const ADMINS = [
  '0xd6A3340C99f2F0d89Bd956E9F8F1AECD2f598437', // DR.MACH
  //   '0x977e0c1005dff8749f8cac22f4df0bd5f013d1a7', // CHUNGUS cake.eth
  //   '0xa3D2124E4023ea5c74dC749012E0B46E42bDD648', // LIME cakevote.eth
  //   '0x4634fC1462B7974dB96B700E9aBe915f0884e60a', // GYOZA cakevote.eth
  //   '0xa7551aBe0A066555cb5d859849426fB55543Ca25', // MUSTARD cakevote.eth
  '0xdb2ff236a2e8e8478c8993749e7f1c1d31c28c02', // BEZ
].map((address) => address.toLowerCase())
export const IPFS_GATEWAY = 'https://gateway.ipfs.io/ipfs'
export const SNAPSHOT_VERSION = '0.1.3'
export const PANCAKE_SPACE = 'cadinuvote.eth'
export const VOTE_THRESHOLD = '100M'